import { cn as a } from "../../../lib/utils.es.js";
import C from "../../layout/container/Container.es.js";
import m from "../../shared/text/Text.es.js";
import u from "../../shared/button/Button.es.js";
import z from "../../shared/heading/Heading.es.js";
import y from "../../shared/icon/Icon.es.js";
import { FooterLinkProvider as k } from "./context/FooterLinkProvider.es.js";
import { useFooterLink as v } from "./context/useFooterLink.es.js";
import { jsx as l, jsxs as r } from "react/jsx-runtime";
var d = "lib:hover:opacity-80 lib:transition-opacity", w = "lib:max-md:text-sm", g = "lib:flex lib:flex-col lib:gap-y-8 lib:md:gap-y-4 lib:w-full lib:md:w-1/2 lib:md:min-w-[21rem] lib:xl:w-1/3", N = "lib:flex lib:flex-col lib:gap-y-6 lib:md:gap-y-3 lib:w-full lib:md:w-1/2", _ = "footer", I = ({ className: n, children: b, link: o, as: c, ...s }) => /* @__PURE__ */ l(c ?? _, {
  className: a("lib:bg-black", n),
  "data-slot": "footer",
  ...s,
  children: /* @__PURE__ */ l(C, {
    className: "lib:px-4 lib:py-8 lib:md:px-8 lib:md:py-11 lib:xl:px-16 lib:2xl:px-36",
    children: /* @__PURE__ */ l(k, {
      link: o,
      children: b
    })
  })
}), M = ({ className: n, links: b, contacts: o, socials: c, accentLinks: s, ...f }) => {
  const h = v(), p = (i) => i.map(({ label: e, "data-testid": t, ...x }) => /* @__PURE__ */ l("li", {
    className: "lib:flex",
    children: /* @__PURE__ */ l(m, {
      asChild: !0,
      className: a(d, w),
      color: "white",
      fontFamily: "cygre",
      size: "sm",
      children: /* @__PURE__ */ l(h, {
        ...x,
        "data-testid": t,
        children: e
      })
    })
  }, x.href ?? e));
  return /* @__PURE__ */ r("div", {
    className: a("lib:flex lib:w-full lib:flex-wrap lib:justify-between lib:gap-y-11 lib:md:pt-6", n),
    "data-slot": "footer-top",
    ...f,
    children: [
      /* @__PURE__ */ r("ul", {
        className: g,
        children: [p(b.col1), /* @__PURE__ */ l("li", {
          className: "lib:mt-3 lib:s:mt-6 lib:flex lib:items-center lib:gap-x-4 lib:s:gap-x-3 lib:max-s:mb-1 lib:md:gap-x-4",
          children: c?.map(({ link: i, icon: e, "data-testid": t }) => /* @__PURE__ */ l(u, {
            asChild: !0,
            "data-testid": t,
            icon: !0,
            variant: "primary",
            children: /* @__PURE__ */ l(h, {
              href: i,
              rel: "noreferrer nofollow",
              target: "_blank",
              children: /* @__PURE__ */ l(y, {
                className: "lib:size-8 lib:shrink-0",
                name: e
              })
            })
          }, i))
        })]
      }),
      /* @__PURE__ */ r("ul", {
        className: g,
        children: [p(b.col2), /* @__PURE__ */ l("li", {
          className: "lib:flex lib:s:contents lib:flex-col lib:gap-y-4",
          children: s?.map(({ href: i, label: e, icon: t, "data-testid": x, ...F }) => /* @__PURE__ */ r("div", {
            className: a(d, "lib:flex lib:items-center lib:gap-x-3", i === s?.[0]?.href && "lib:mt-5 lib:s:mt-2 lib:md:mt-6"),
            children: [/* @__PURE__ */ l(u, {
              className: "lib:size-10 lib:md:size-12!",
              icon: !0,
              variant: "primary",
              children: /* @__PURE__ */ l(y, {
                className: "lib:size-6 lib:shrink-0",
                name: t
              })
            }), /* @__PURE__ */ l(m, {
              asChild: !0,
              className: a(w),
              color: "white",
              size: "sm",
              weight: "bold",
              children: /* @__PURE__ */ l(h, {
                ...F,
                "data-testid": x,
                href: i,
                children: e
              })
            })]
          }, i ?? e))
        })]
      }),
      /* @__PURE__ */ r("address", {
        className: a(g, "lib:w-full! lib:gap-y-8! lib:not-italic lib:md:max-xl:-mt-46 lib:xl:w-1/3!"),
        children: [o.phones.map((i, e) => /* @__PURE__ */ l(z, {
          asChild: !0,
          className: a(d, "lib:mb-4 lib:md:w-full", e === 0 && "lib:max-s:mt-5 lib:max-s:mb-6"),
          color: "white",
          fontFamily: "cygre",
          size: "h3",
          weight: "semibold",
          children: /* @__PURE__ */ l("a", {
            href: `tel:${i}`,
            children: i
          })
        }, i)), /* @__PURE__ */ l("div", {
          className: "lib:contents lib:flex-wrap lib:gap-y-8 lib:md:flex",
          children: o.other?.map((i) => {
            const e = i.type === "link" ? `${i.label}-${i.value.href}` : `${i.label}-${i.value}`;
            return /* @__PURE__ */ r("div", {
              className: "lib:flex lib:w-full lib:flex-col lib:gap-y-4 lib:md:w-1/2 lib:xl:w-full",
              children: [
                /* @__PURE__ */ l(m, {
                  as: "span",
                  className: "lib:text-dark-30",
                  color: "unset",
                  fontFamily: "cygre",
                  size: "sm",
                  weight: "semibold",
                  children: i.label
                }),
                i.type === "text" && /* @__PURE__ */ l(m, {
                  as: "p",
                  className: "lib:leading-5.5",
                  color: "white",
                  fontFamily: "cygre",
                  size: "sm",
                  weight: "semibold",
                  children: i.value
                }),
                i.type === "link" && /* @__PURE__ */ l(m, {
                  asChild: !0,
                  className: a(d),
                  color: "white",
                  fontFamily: "cygre",
                  size: "xl",
                  weight: "semibold",
                  children: /* @__PURE__ */ l("a", {
                    href: i.value.href,
                    children: i.value.label
                  })
                })
              ]
            }, e);
          })
        })]
      })
    ]
  });
}, U = ({ className: n, col2: b, col3: o, ...c }) => {
  const s = v(), f = (h, p = "sm") => /* @__PURE__ */ l("ul", {
    className: N,
    children: h.map(({ label: i, "data-testid": e, ...t }) => /* @__PURE__ */ l("li", {
      className: "lib:flex",
      children: /* @__PURE__ */ l(m, {
        asChild: !0,
        className: a(d, "lib:text-dark-20"),
        color: "unset",
        fontFamily: "cygre",
        size: p,
        children: /* @__PURE__ */ l(s, {
          ...t,
          "data-testid": e,
          children: i
        })
      })
    }, t.href ?? i))
  });
  return /* @__PURE__ */ r("div", {
    className: a("lib:s:mt-7 lib:flex lib:justify-between lib:gap-y-3 lib:border-white/10 lib:s:border-t lib:pt-16 lib:s:pt-7 lib:max-md:flex-wrap", n),
    "data-slot": "footer-bottom",
    ...c,
    children: [
      /* @__PURE__ */ l("ul", {
        className: a(N, "lib:max-md:order-3 lib:max-md:mt-7.5"),
        children: /* @__PURE__ */ l("li", {
          className: "lib:flex",
          children: /* @__PURE__ */ r(m, {
            className: "lib:text-dark-20",
            color: "unset",
            fontFamily: "cygre",
            size: "caption-lg",
            children: [
              "© ",
              (/* @__PURE__ */ new Date()).getFullYear(),
              " Российское общество",
              /* @__PURE__ */ r(s, {
                className: d,
                href: "https://znanierussia.ru/",
                children: [" ", "«Знание»"]
              })
            ]
          })
        })
      }),
      f(b, "caption-lg"),
      f(o, "caption-lg")
    ]
  });
};
export {
  I as Footer,
  U as FooterBottom,
  M as FooterTop
};
